module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921064149_T.40ffacf3.jpg";